import firebaseAdmin from './firebase'

export const ACCESS_TOKEN_KEY = 'access_token'

export const USER_KEY = 'persist:USER'
export const LOGIN_URL = '/login'

export const clearAccessToken = () => localStorage.removeItem(ACCESS_TOKEN_KEY)
export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY)
export const setAccessToken = (token: string) => localStorage.setItem(ACCESS_TOKEN_KEY, token)

/**
 * Removes saved profile from session storage
 */
export function clearProfile() {
	localStorage.removeItem(USER_KEY)
}

/**
 * Redirect user into login page
 */
export function login() {
	window.location.replace(LOGIN_URL)
}

/**
 * Build a login path that remembers where the user was heading, so we can
 * send them back there after a successful login. Universal for every
 * protected route (deep links from e-mails, session expiry, ...).
 *
 * @param loginPath resolved login route (e.g. t('paths:login|path'))
 * @param target optional destination; defaults to the current location
 */
export function buildLoginRedirectPath(loginPath: string, target?: string) {
	const destination = target ?? (window.location.pathname + window.location.search)
	const shouldRemember = Boolean(destination) && destination !== '/' && !destination.startsWith(loginPath)
	return shouldRemember ? `${loginPath}?redirect=${encodeURIComponent(destination)}` : loginPath
}

/**
 * @return boolean
 *
 * check if token is exist and try to decoded
 */
export function isLoggedIn() {
	try {
		const token = getAccessToken()
		if (!token) {
			return false
		}

		return true
	} catch (error) {
		return false
	}
}

/**
 * @return boolean
 *
 * check if token is exist and try to decoded
 */
export async function isLoggedInAsync() {
	try {
		if (getAccessToken()) {
			return true
		}
		const token = await firebaseAdmin?.auth()?.currentUser?.getIdToken(true)
		if (token) {
			setAccessToken(token)
		}
		if (!token) {
			return false
		}

		return true
	} catch (error) {
		return false
	}
}
